import React, { useState } from "react";
import { Box, Typography, TextField, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Login = () => {
    const navigate = useNavigate();

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const handleLogin = (e) => {
        e.preventDefault();

        // Temporary login
        // Replace this with backend authentication later
        if (username === "admin" && password === "123456") {
            localStorage.setItem("isAdminLoggedIn", "true");

            navigate("/admin");
        } else {
            setError("Incorrect username or password");
        }
    };

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#f5f1eb",
                padding: 3,
            }}
        >
            <Box
                component="form"
                onSubmit={handleLogin}
                sx={{
                    width: "100%",
                    maxWidth: "420px",
                    padding: {
                        xs: "35px 25px",
                        sm: "50px 45px",
                    },
                    backgroundColor: "#fff",
                    borderRadius: "16px",
                    boxShadow: "0 10px 40px rgba(0, 0, 0, 0.08)",
                }}
            >
                {/* Title */}
                <Typography
                    sx={{
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "2rem",
                        fontWeight: 600,
                        textAlign: "center",
                        color: "#222",
                        marginBottom: "8px",
                    }}
                >
                    Welcome Back
                </Typography>

                <Typography
                    sx={{
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "0.9rem",
                        textAlign: "center",
                        color: "#888",
                        marginBottom: "35px",
                    }}
                >
                    Sign in to manage your website
                </Typography>

                {/* Username */}
                <TextField
                    fullWidth
                    label="Username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    sx={{
                        marginBottom: 2,
                        "& .MuiOutlinedInput-root": {
                            borderRadius: "8px",
                        },
                    }}
                />

                {/* Password */}
                <TextField
                    fullWidth
                    label="Password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    sx={{
                        marginBottom: 2,
                        "& .MuiOutlinedInput-root": {
                            borderRadius: "8px",
                        },
                    }}
                />

                {/* Error */}
                {error && (
                    <Typography
                        sx={{
                            color: "#d32f2f",
                            fontSize: "0.85rem",
                            marginBottom: 2,
                            textAlign: "center",
                        }}
                    >
                        {error}
                    </Typography>
                )}

                {/* Login Button */}
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{
                        height: "48px",
                        borderRadius: "8px",
                        backgroundColor: "#222",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "0.9rem",
                        textTransform: "none",
                        boxShadow: "none",

                        "&:hover": {
                            backgroundColor: "#444",
                            boxShadow: "none",
                        },
                    }}
                >
                    Login
                </Button>
            </Box>
        </Box>
    );
};

export default Login;